import { normalizeText, splitText } from "@flixbus-phx/marketplace-common";
import { Article } from "../../types";

const normalizeAndSplitText = (text: string) => {
  const normalizedText = normalizeText(text);
  return splitText(normalizedText);
};

const matchesSearchWords = (searchWords: Array<string>, text: string) => {
  const textElements = normalizeAndSplitText(text);
  return searchWords.some((searchWord) => textElements.some((element) => element.includes(searchWord)));
};

export default (searchValue: string, articles: Array<Article>) => {
  const searchWords = normalizeAndSplitText(searchValue);

  return articles.filter((article) =>
    [article.headline, article.category, article.content].some((field) => matchesSearchWords(searchWords, field))
  );
};
